var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex } from 'shared/components';
export var IFrameHeaderContainer = function (_a) {
    var children = _a.children;
    return (_jsxs(Flex, __assign({ direction: "column", zIndex: "200", w: "100%", pos: "relative" }, { children: [_jsx(Flex, __assign({ direction: "row", alignItems: "center", p: 3, background: "white" }, { children: _jsx(Box, __assign({ w: "100%", "data-testid": "iframeHeader" }, { children: children })) })), _jsx(Box, { boxShadow: '0px 0px 8px 0px #482d28', height: "1px", zIndex: "-1", mr: 1, ml: 1 })] })));
};
